import "./Assurance.css";
const Assurance = () => (
  <section className="assuranceSection">
    <div className="assuranceDiv">
      <span className="horizontalLine"></span>
      <h1 className="assuranceH1">You're in good hands</h1>
      <p className="assuranceP">
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Perferendis
        quibusdam voluptatibus porro quod ab nemo, corporis molestias, dolorum
        cum inventore sapiente nisi exercitationem sint similique quaerat
        asperiores, quidem facilis laboriosam voluptas. Id assumenda porro
        similique eaque pariatur quos, aperiam eius.
      </p>
      <button className="assuranceBtn">
        Learn more
        <img src="./images/arrowW.png" alt="" />
      </button>
    </div>
  </section>
);
export default Assurance;
